<template>
  <div class="d-flex flex-row h-100 w-100">
    <div
      class="login-background d-none d-lg-flex"
      :class="{ 'login-background--classic': !showNewBanner }"
    >
      <!-- Banner novo com CTA para o novo login -->
      <div v-if="showNewBanner" class="login-presentation">
        <img
          class="login-presentation-logo"
          aria-hidden="true"
          src="https://assets.teamculture.com.br/vendor/teamculture-design-system/brand/logo-teamculture-text-white-monogram-transp.svg"
          :alt="labels.teamCultureLogo"
        />
        <h2 class="login-presentation-headline">
          {{ labels.newLoginHeadline }}
        </h2>
        <p class="login-presentation-description">
          {{ labels.newLoginDescription }}
        </p>
        <a
          :href="newLoginUrl"
          class="login-presentation-cta"
          rel="noopener noreferrer"
        >
          {{ labels.newLoginCta }}
        </a>
      </div>
      <!-- Imagem classica (original) -->
      <div v-else class="login-video-wrapper">
        <img
          class="w-100"
          aria-hidden="true"
          src="https://static.teamculture.com.br/logos/teamculture-wall.png"
          :alt="labels.teamCultureLogo"
        />
      </div>
    </div>
    <div class="login-content-wrapper flex-grow-1" :class="variant">
      <div class="login-content w-100">
        <b-row class="m-0 p-0 h-100 w-100">
          <router-view>
            <template slot="logo">
              <div class="w-100 text-center">
                <img
                  id="tc-img"
                  aria-hidden="true"
                  src="../assets/logos/logo.svg"
                  :alt="labels.teamCultureLogo"
                  class="logo-block"
                />
              </div>
            </template>
          </router-view>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { showChat } from '@/helpers/chat'

// Flag: true = banner novo com CTA, false = imagem classica original
const SHOW_NEW_LOGIN_BANNER = false

export default {
  data() {
    return {
      showNewBanner: SHOW_NEW_LOGIN_BANNER,
    }
  },
  computed: {
    variant: function() {
      return this.$route && this.$route.meta
        ? this.$route.meta.variant
        : 'bg-white'
    },
    logoVideo: function() {
      const random = Math.floor(Math.random() * 3 + 1)
      return `login/login-mov${random}.mp4`
    },
    ...mapGetters({
      resources: 'resources',
    }),
    newLoginUrl: function() {
      var host = process.env.VUE_APP_NEW_LINK || ''
      return host ? host + '?origin=legacy-login' : '#'
    },
    labels: function() {
      return {
        teamCultureLogo: this.resources.general.teamCultureLogo,
        newLoginHeadline: this.resources.general.newLoginHeadline,
        newLoginDescription: this.resources.general.newLoginDescription,
        newLoginCta: this.resources.general.newLoginCta,
      }
    },
  },
  mounted() {
    showChat()
  },
  updated() {
    showChat()
    this.$root.$emit('recordPage')
  },
}
</script>

<style lang="scss">
#tc-img {
  @media (max-width: 425px) {
    max-height: 100px;
  }
}
</style>

<style scoped lang="scss">
.logo-inline {
  max-width: 300px;
}

.logo-block {
  width: auto;
  max-height: 150px;
  padding-bottom: 20px;
}

.login-background {
  width: calc(100% - 500px);
  height: 100vh;
  background-color: #131d21;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      rgba(19, 29, 33, 0.95) 0%,
      rgba(27, 27, 27, 0.85) 100%
    );
    z-index: 1;
  }

  &--classic {
    background-color: #000000;

    &::before {
      display: none;
    }
  }
}

.login-video-wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  .logo-video {
    z-index: 0;
    min-height: 100%;
    min-width: 100%;
  }
}

.login-presentation {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px;
  text-align: center;
  max-width: 480px;

  &-logo {
    width: 240px;
    height: auto;
    margin-bottom: 48px;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3));
  }

  &-headline {
    font-family: 'Bree Serif', Georgia, serif;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.2;
    color: #ffffff;
    margin-bottom: 16px;
    letter-spacing: -0.01em;
    white-space: nowrap;
  }

  &-description {
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.7);
    max-width: 440px;
    margin-bottom: 32px;
  }

  &-cta {
    display: inline-block;
    padding: 14px 40px;
    background-color: #7b0000;
    color: #ffffff;
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    font-size: 1rem;
    font-weight: 600;
    text-decoration: none;
    border-radius: 6px;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      background-color: #6e0000;
      box-shadow: 0 4px 6px -1px rgba(27, 27, 27, 0.2),
        0 2px 4px -2px rgba(27, 27, 27, 0.1);
      color: #ffffff;
      text-decoration: none;
    }

    &:active {
      background-color: #5c0000;
    }
  }
}

.login-content-wrapper {
  display: flex;
  flex-direction: row;
  z-index: 1;

  .login-content {
    position: relative;
    z-index: 1;
    min-width: 0px;
    flex: 1 1 auto;
    overflow: auto;
    flex-grow: 1;

    @media (max-width: 575.98px) {
      padding: 40px;
    }
    @media (max-width: 378px) {
      padding: 25px;
    }
    @media (max-width: 330px) {
      padding: 10px;
    }
    @media (min-width: 576px) and (max-width: 991.98px) {
      padding: 60px;
      .row {
        padding: 30px !important;
      }
    }
    @media (min-width: 992px) {
      padding: 50px;
      width: 500px !important;
    }
  }
}
</style>
